import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { hideAlert } from "../../store/reducers/alertReducer";
import { useDispatch } from "react-redux";

const Toast = ({ isVisible, text, type }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isVisible) {
      // Show the toast based on type
      const toastOptions = {
        onClose: () => dispatch(hideAlert()),
      };

      switch (type) {
        case "success":
          toast.success(text, toastOptions);
          break;
        case "error":
          toast.error(text, toastOptions);
          break;
        default:
          toast(text, toastOptions);
          break;
      }
    }
  }, [isVisible, text, type, dispatch]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
    />
  );
};

export default Toast;
